
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Innovacabsbookinginpune() {



    const cardData =
    {
        keyword: 'Innova Cabs Booking in Pune',
        heading: 'S9 Travels: Innova Cabs Booking in Pune',
        headingDescription: 'S9 Travels offers Innova Cabs for a comfortable, reliable, and premium travel experience in Pune. Whether you are traveling for a family trip, a corporate event, or a weekend getaway, our Innova cabs are the perfect choice. With spacious interiors, luxury features, and a smooth ride, you can enjoy every journey with ease. Our professional drivers ensure a safe and hassle-free experience from start to finish.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada is a must-see for history buffs. This grand palace was once the seat of the Peshwa rulers and offers fascinating glimpses into Pune's royal past. The light and sound show in the evening is a popular attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892, this beautiful palace is known for its historical significance, as it served as a prison for Mahatma Gandhi during the Indian independence struggle. The palace is surrounded by lush gardens and serves as a reminder of India’s freedom movement."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. A popular trekking destination, it is also rich in history, having been the site of many battles, including the famous Battle of Sinhagad."
    },
    {
      "title": "Osho Ashram",
      "description": "For those seeking peace and tranquility, the Osho Ashram in Pune is a renowned spiritual retreat. It offers yoga, meditation, and spiritual practices to rejuvenate your mind and body. It’s an ideal place for those looking for a calm and reflective experience."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This ancient rock-cut temple, dedicated to Lord Shiva, is located right in the heart of Pune. Carved out of a single rock, it is a serene and historical place, providing insight into ancient Indian architecture and religion."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses a wide collection of artifacts, including sculptures, paintings, and other cultural exhibits. It showcases the rich artistic heritage of India, with a special emphasis on Maharashtra's traditional art forms."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "For nature lovers and those looking for a peaceful escape, Khadakwasla Dam offers a scenic location to relax. It’s a popular spot for picnics, and you can enjoy the beauty of the surrounding hills and the cool breeze by the water."
    },
    {
      "title": "Fergusson College Road",
      "description": "Known as the heart of Pune's youthful and energetic vibe, Fergusson College Road is a bustling area filled with cafes, bookshops, and vibrant street markets. It’s a great spot to experience Pune’s lively culture and shop for souvenirs."
    },
    {
      "title": "Lal Mahal",
      "description": "A significant historical landmark, Lal Mahal was the residence of Chhatrapati Shivaji Maharaj during his youth. It’s an important monument that offers insights into the life of the great Maratha king."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as the Japanese Garden, this beautifully landscaped park is a peaceful retreat with lovely walking paths, koi ponds, and traditional Japanese architecture. It's an ideal place for a serene walk or a family outing."
    }
],

"services": [
    {
      "name": "Innova Cabs Pune",
      "description": "Looking for a reliable and comfortable ride in Pune? Choose from our fleet of Innova cabs for a spacious and premium travel experience. Whether you need a ride for a short trip, a local excursion, or an outstation journey, our Innova taxis provide a high level of comfort and convenience for every traveler."
    },
    {
      "name": "Innova Taxi Booking in Pune",
      "description": "Booking an Innova taxi in Pune is now easier than ever! Simply choose from our wide range of options, including one-way and round-trip bookings, and enjoy a comfortable ride to your destination. Our Innova taxis are perfect for both local travel and long-distance journeys."
    },
    {
      "name": "Pune Innova Car Hire",
      "description": "Need to hire an Innova for a day, a weekend getaway, or an extended trip? We offer Innova car hire services in Pune, with flexible options that suit your specific travel needs. Our fleet of Innova cars is well-maintained and comes with experienced drivers who know the local routes."
    },
    {
      "name": "Innova Cabs for Outstation from Pune",
      "description": "Planning an outstation trip? Choose Innova cabs for a comfortable and reliable journey. Whether you’re traveling to Mumbai, Goa, or Shirdi, our Innova taxis provide ample space and comfort for long-distance travel. Book your Innova cab for an outstation trip from Pune now!"
    },
    {
      "name": "Pune Innova Taxi Service",
      "description": "Experience premium travel with our Pune Innova taxi service. Our professional drivers ensure a smooth, safe, and enjoyable ride for both local travel and outstation journeys. Whether you need a pick-up from the airport or a trip to a popular tourist destination, our Innova taxis are at your service."
    },
    {
      "name": "Book Innova Cab in Pune",
      "description": "Booking an Innova cab in Pune is hassle-free! Whether you're planning a short trip, business trip, or family outing, our Innova cabs are available for your convenience. Just let us know the time, and we will have your ride ready. Innova cabs are perfect for those seeking comfort and luxury."
    },
    {
      "name": "Innova Taxi Rental Pune",
      "description": "If you need to rent an Innova taxi in Pune for a day or an extended period, we have flexible options to meet your needs. Rent an Innova taxi and enjoy the convenience of traveling in style with ample space for your group or family."
    },
    {
      "name": "Pune Airport Innova Cabs",
      "description": "Arriving or departing from Pune Airport? Choose our Innova cabs for a premium airport transfer service. Our drivers are punctual and knowledgeable, ensuring you have a seamless travel experience. Enjoy the luxury and comfort of a private Innova taxi for your airport pick-up or drop-off."
    },
    {
      "name": "Pune Innova Car Booking",
      "description": "Booking an Innova car for your next trip in Pune is easy and quick. Our fleet of Innova cars ensures you get the best experience, whether you're traveling for business or leisure. Book a Pune Innova car and enjoy a comfortable ride with your family or colleagues."
    },
    {
      "name": "Innova Cabs for Local Travel",
      "description": "For local travel within Pune, choose our Innova cabs. Whether you’re attending a meeting, visiting tourist spots, or heading to a wedding or event, our Innova cabs provide ample space, comfort, and convenience. Ideal for families, groups, and corporate travel, our Innova taxis ensure a stress-free local commute."
    },
    {
      "name": "Book Innova for Outstation",
      "description": "Heading out of Pune? Book an Innova taxi for your outstation trip to popular destinations like Mahabaleshwar, Kolhapur, Shirdi, and beyond. Innova taxis are the best choice for outstation travel as they provide a comfortable and spacious ride for long distances. Book now and enjoy your journey!"
    },
    {
      "name": "Affordable Innova Cabs in Pune",
      "description": "Looking for an affordable way to travel in style? Our Innova cabs offer the best balance of luxury and affordability. You don’t have to break the bank to enjoy a comfortable and spacious ride in Pune. Get in touch for competitive rates on our Innova taxis!"
    },
    {
      "name": "Luxury Innova Taxi for Hire in Pune",
      "description": "For those who want to travel in style, we offer luxury Innova taxi hire in Pune. Our luxury Innova cabs are equipped with premium features and driven by professional chauffeurs to ensure that you travel in utmost comfort. Perfect for corporate events, weddings, or any special occasion."
    },
    {
      "name": "Corporate Innova Cabs Pune",
      "description": "For corporate travel in Pune, our Innova cabs are the ideal choice. Whether you need to transport employees for a meeting, event, or conference, our Innova taxis offer the perfect solution. We provide tailored services for businesses, ensuring punctuality, comfort, and reliability."
    }
  ],

"tableData": [
  ["Innova Cabs Pune", "Innova Taxi Booking in Pune"],
  ["Pune Innova Car Hire", "Innova Cabs for Outstation from Pune"],
  ["Pune Innova Taxi Service", "Book Innova Cab in Pune"],
  ["Pune Airport Innova Cabs", "Pune Innova Car Booking"],
  ["Innova Cabs for Local Travel", "Book Innova for Outstation"],
  ["Affordable Innova Cabs in Pune", "Luxury Innova Taxi for Hire in Pune"],
  ["Corporate Innova Cabs Pune", ""],
  ["", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of time and reliability. When you book an Innova cab in Pune with us, you can be sure of a punctual, hassle-free ride. Whether it's for business, family trips, or any special event, our drivers ensure timely pickups and drop-offs."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "The Toyota Innova is known for its spacious and luxurious interiors, making it ideal for both long-distance travel and city trips. With ample legroom, comfortable seating, air conditioning, and well-maintained interiors, our Innova cabs provide a premium experience for all passengers."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced professionals who know the best routes and traffic patterns in Pune and beyond. They ensure your journey is smooth, safe, and comfortable, while offering assistance as needed."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Innova cabs in Pune. Our pricing is transparent, with no hidden charges. We provide a clear breakdown of costs during the booking process, so you can plan your trip without any surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. Our Innova cabs are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring your ride is secure and comfortable throughout your journey."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you need an Innova cab for early morning pickups or late-night travel, S9 Travels is available 24/7. Our customer service team is ready to assist you at any time, ensuring that your booking process is seamless."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking an Innova cab in Pune with S9 Travels is simple and convenient. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance and guidance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're traveling for a business event, family gathering, or a sightseeing tour, we offer customized travel packages with Innova cabs. Let us know your preferences, and we will tailor the trip to suit your needs, ensuring a unique and enjoyable experience."
  }
]

























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova cab in Pune with S9 Travels?',
            answer: 'Booking an Innova cab is easy! You can book online through our website or app, or simply contact our customer service team for personalized assistance.',
          },
          {
            question: 'What is the seating capacity of the Innova cab?',
            answer: 'The Toyota Innova can comfortably accommodate up to 6 passengers, making it perfect for family trips, group outings, or corporate travel.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced in both short and long-distance travel, ensuring a safe and smooth journey in and around Pune.',
          },
          {
            question: 'What types of payment options are available for Innova cab bookings?',
            answer: 'We offer several payment options, including cash, credit/debit cards, and online payments via our app for your convenience.',
          },
          {
            question: 'Can I hire an Innova cab for a round trip in Pune?',
            answer: 'Yes, round trips can be arranged. Just provide us with your return details, and we’ll ensure a comfortable and timely return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring full transparency in pricing.',
          },
          {
            question: 'Can I use an Innova cab for sightseeing in Pune or nearby areas?',
            answer: 'Yes, our Innova cabs are available for sightseeing tours in Pune and surrounding areas. Explore popular tourist destinations with the comfort of a spacious and well-maintained vehicle.',
          },
          {
            question: 'What is the luggage allowance for an Innova cab?',
            answer: 'The Innova has ample space for standard luggage. If you have more luggage or specific requirements, please inform us during the booking process, and we will make necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel with Innova cabs?',
            answer: 'Yes, we provide Innova cabs for corporate events, group travel, or family outings in Pune. We ensure a comfortable and professional experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Innova cab booking in Pune?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable ride with professional drivers, well-maintained vehicles, and excellent customer service. We ensure your trip in an Innova cab is smooth, safe, and memorable.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Manoj Gupta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an Innova cab with S9 Travels for a family trip around Pune. The vehicle was clean, spacious, and very comfortable. The driver was professional, and the trip was hassle-free. Highly recommend S9 Travels for anyone needing an Innova cab!”',
        },
        {
          name: 'Mrs. Priya Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our experience with S9 Travels for an Innova cab booking was excellent. The vehicle was top-notch, and the driver was courteous and knowledgeable. We’ll definitely book again for future trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Innova Cabs / Taxi Booking in Pune",
        "description": "Book Innova cabs and taxis in Pune with S9 Travels. Offering outstation and local travel options, affordable Innova car hire, luxury Innova taxis rentals. Reserve your Innova cab for airport transfers, corporate travel, and more. Reliable, safe, and comfortable service for all your travel needs.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
          <Helmet>
        <title>Innova Cabs Booking in Pune | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Innova cabs and taxis in Pune with S9 Travels. Choose from outstation, local travel, airport transfers, corporate travel, and more. Affordable Innova car hire and luxury taxis available." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacabsbookinginpune;